var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card, Image, ProgressBar, Tag } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { enumValues, isFunction } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { bool, eventListener, number, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { LanguageService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import ConfirmedSVG from '../../assets/images/icons/Confirmed.svg';
import PendingUrgentSVG from '../../assets/images/icons/Urgent.svg';
import BlockedSVG from '../../assets/images/icons/dls_cancel.svg';
import TASK_ITEM_STATUS from '../../constants/task-item-status';
import ScheduleTasksProgressCardAPI from './schedule-tasks-progress-card-api';
import moment from 'moment';
import './schedule-tasks-progress-card.css';
import { TaskListCardUtils } from '../../util/task-list-card-utils';
let ScheduleTasksProgressCard = class ScheduleTasksProgressCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { cdMedico, eventType, onClick, scheduleNumber, nrSeqAtendimento } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        cdMedico,
                        eventType,
                        nrSeqAtendimento,
                        scheduleNumber,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        cdMedico: string,
        completedTasks: number,
        date: string,
        eventType: string,
        identifier: number,
        onClick: eventListener,
        onSelect: eventListener,
        scheduleNumber: number,
        selectable: bool.notEnumerable(),
        selected: bool.notEnumerable(),
        selectionType: oneOf(enumValues(SelectionType)).notEnumerable(),
        showDate: bool,
        showRemainingDays: bool,
        title: string,
        totalTasks: number,
        uuid: string
    }; }
    static { this.defaultProps = {
        selectable: false,
        selected: false,
        showDate: true,
        showRemainingDays: true
    }; }
    getTaskStatus(date, actualDate) {
        const { completedTasks, totalTasks, calculatedBlockedTasks } = this.props;
        const difInDays = date.diff(actualDate.startOf('day'), 'days');
        if (calculatedBlockedTasks === totalTasks)
            return TASK_ITEM_STATUS.BLOCKED;
        if (completedTasks === totalTasks)
            return TASK_ITEM_STATUS.COMPLETED;
        if (difInDays >= 4)
            return TASK_ITEM_STATUS.PENDING_NORMAL;
        return TASK_ITEM_STATUS.PENDING_URGENT;
    }
    getStatusIcon(status) {
        if (status === TASK_ITEM_STATUS.BLOCKED)
            return BlockedSVG;
        if (status === TASK_ITEM_STATUS.COMPLETED)
            return ConfirmedSVG;
        if (status === TASK_ITEM_STATUS.PENDING_URGENT)
            return PendingUrgentSVG;
        return '';
    }
    renderStatusIcon(status) {
        const statusIcon = this.getStatusIcon(status);
        return (React.createElement(Image, { src: statusIcon, className: 'schedule-tasks-progress-card-status-icon', alt: `${status}-icon` }));
    }
    renderDate(date) {
        const { showDate } = this.props;
        const scheduleHour = date.format('HH:mm');
        const localeStr = LanguageService.getCurrentLanguage().replace('_', '-');
        const localeDate = moment(date).locale(localeStr);
        if (!showDate) {
            return null;
        }
        return (React.createElement("div", { className: 'schedule-tasks-progress-card-date' }, `${localeDate.format('ll')} - ${scheduleHour}`));
    }
    renderBottomContent() {
        const { completedTasks, totalTasks, eventType } = this.props;
        const tasksCompletedExpression = MessageService.translate('patient.tasks-concluded');
        const taskEventExpression = MessageService.translate(TaskListCardUtils.getExpressionForTaskTag(eventType));
        return (React.createElement("div", { className: 'schedule-tasks-progress-card-bottom-content' },
            taskEventExpression &&
                React.createElement("div", { className: 'schedule-tasks-progress-card-task-process-type' },
                    React.createElement(Tag, { value: taskEventExpression, formatters: {} })),
            React.createElement("div", { className: 'schedule-tasks-progress-card-task-progress' },
                React.createElement(ProgressBar, { rightText: `${completedTasks}/${totalTasks} ${tasksCompletedExpression}`, currentPart: completedTasks, maxParts: totalTasks }))));
    }
    getTimeLeftExpression(date, actualDate) {
        const difInDays = date.diff(actualDate.clone().startOf('day'), 'days');
        if (difInDays === 0)
            return MessageService.translate('tws.datepicker.today');
        if (difInDays === 1)
            return `${difInDays} ${MessageService.translate('patient.day-left')}`;
        return `${difInDays} ${MessageService.translate('patient.days-left')}`;
    }
    renderTopContent(status, date, actualDate) {
        const { showRemainingDays, title } = this.props;
        const isTaskCompletedOrUrgent = status === TASK_ITEM_STATUS.COMPLETED
            || status === TASK_ITEM_STATUS.PENDING_URGENT
            || status === TASK_ITEM_STATUS.BLOCKED;
        return (React.createElement("div", { className: 'schedule-tasks-progress-card-top-content' },
            React.createElement("div", { className: 'schedule-tasks-progress-card-title' }, title),
            React.createElement("div", { className: 'schedule-tasks-progress-card-time-left' },
                showRemainingDays &&
                    (React.createElement("span", { className: 'schedule-tasks-progress-card-days-left' }, this.getTimeLeftExpression(date, actualDate))),
                isTaskCompletedOrUrgent && this.renderStatusIcon(status))));
    }
    renderScheduleTasksProgressCard() {
        const { date } = this.props;
        const momentDate = moment(date);
        const actualDate = moment();
        const status = this.getTaskStatus(momentDate, actualDate);
        return (React.createElement("div", { className: "schedule-tasks-progress-card-container" },
            React.createElement("div", { className: 'schedule-tasks-progress-card-content' },
                this.renderTopContent(status, momentDate, actualDate),
                this.renderDate(momentDate),
                this.renderBottomContent())));
    }
    render() {
        const { selectable, selectionType = SelectionType.NONE, selected, onSelect, uuid } = this.props;
        return (React.createElement(Card, { className: 'schedule-tasks-progress-card', onClick: () => this.onClick(), key: uuid, onSelect: onSelect, selectable: selectable, selectionType: selectionType, selected: selected, transparent: false, uuid: uuid, width: 12 }, this.renderScheduleTasksProgressCard()));
    }
};
ScheduleTasksProgressCard = __decorate([
    AwesomeComponent({ api: ScheduleTasksProgressCardAPI, type: ComponentType.DATA_DISPLAY })
], ScheduleTasksProgressCard);
export default ScheduleTasksProgressCard;
//# sourceMappingURL=schedule-tasks-progress-card.js.map